import authService from "data/auth"
import fetch from 'data/lib/_fetch'
import { local, setlocal } from 'data/lib/local-json'
import { allowReportOnly } from 'data/lib/report-only'
import _ from 'lodash'

// Built off Fetch API
const checkStatus: ((value: Response) => Response | PromiseLike<Response>) | null | undefined = async (response) => {
  if (response['url'].includes('report/underwritingworkbook') && !response.ok) return response
  if (!response.ok) {
    let error
    try {
      error = await response.json()
      if (error == 'Invalid token...' || error.message == 'session-expired') {
        setlocal('rdcf_loggedOutDueToInactivity', true)
        authService.logout()
      }
    } catch (e) {
      error = {message: (await response.text()) || response.statusText}
    }
    throw error
  }
  return response
}

const parseJSON = res => res.json()

const defaultHeaders = () => {
  return {
    headers: {
      'Authorization': `Bearer ${local('auth.token')}`,
      'Content-Type': 'application/json',
      'organizationId': `${_.get(local('auth.profile'), 'organizationId')}`
    }
  }
}

type Options = {
  host?: string,
  headers?: object
}

const defaultOptions: Options = {
  host: process.env.API,
}

const Client = {
  del: (route, data?: {}, options?: Options) => {
    if(!allowReportOnly(route, "DELETE")) return Promise.reject(new Error("You are in Read-Only mode as this organization does not have an active rDCF subscription. Please enter a support ticket to receive information about our subscription plans."))
    const { host, headers } = _.defaultsDeep(options, defaultOptions, defaultHeaders())
    const url = host + route
    const fetchData = {
      method: 'DELETE',
      headers
    }
    if(!_.isEmpty(data)) _.set(fetchData, "body", JSON.stringify(data))
    return fetch(url, fetchData)
      .then(checkStatus)
      .then((res) => {
        return route.includes('report/bidataexport') || route.includes('report/underwritingworkbook') ? res : parseJSON(res)
      })
  },
  get: (route, options?: Options) => {
    const { host, headers } = _.defaultsDeep(options, defaultOptions, defaultHeaders())
    const url = host + route
    const fetchData = {
      method: 'GET',
      headers
    }
    return fetch(url, fetchData)
      .then(checkStatus)
      .then((res)=> {
        return (route.includes('reports/getfile') ? res.blob() :
               (!route.includes('report/bidataexport') &&
               (!route.includes('report/underwritingworkbook'))
               ? parseJSON(res) : res))})
  },
  post: (route, data, options?: Options) => {
    if(!allowReportOnly(route, "POST")) return Promise.reject(new Error("You are in Read-Only mode as this organization does not have an active rDCF subscription. Please enter a support ticket to receive information about our subscription plans."))
    const { host, headers } = _.defaultsDeep(options, defaultOptions, defaultHeaders())
    const url = host + route
    if (headers['Content-Type'] == 'multipart/form-data') {
      // fetch wants to infer the content-type from body being an instance of FormData
      delete headers['Content-Type']
    }
    if (headers['Content-Type'] == 'application/json') {
      data =  JSON.stringify(data)
    }
    const fetchData = {
      method: 'POST',
      body: data,
      headers
    }
    return fetch(url, fetchData)
      .then(checkStatus)
      .then((res)=> { if (!route.includes('import')) return parseJSON(res) })
  },
  patch: (route, data, options?: Options) => {
    if(!allowReportOnly(route, "PATCH")) return Promise.reject(new Error("You are in Read-Only mode as this organization does not have an active rDCF subscription. Please enter a support ticket to receive information about our subscription plans."))
    const { host, headers } = _.defaultsDeep(options, defaultOptions, defaultHeaders())
    const url = host + route
    const fetchData = {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers
    }
    return fetch(url, fetchData)
      .then(checkStatus)
      .then(parseJSON)
  },
  count: (route, options?: Options) => {
    const { host, headers } = _.defaultsDeep(options, defaultOptions, defaultHeaders())
    const url = host + route
    let fetchData = {
      method: 'GET',
      headers
    }
    return fetch(url, fetchData)
      .then(checkStatus)
      .then(res => {
        const range: string = res.headers.get('content-range') || "0"
        const rowCount: number = parseInt(range.match(/\d+$/)![0]) || 0
        return rowCount
      })
  }
}

export default Client
_.set(window, 'client', Client)